"use client";
import t, { useState as s, useEffect as v } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import E from "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es44.js";
import S from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
import d from "styled-components";
import { createChoicesGenerator as b } from "./index.es4.js";
const G = d.div``, P = d.div`
  display: flex;
  justify-content: end;
`, mt = ({
  regionsData: n,
  onChange: f,
  includeTypes: y,
  previousRegion: r,
  previousComparisonRegions: p = [],
  clearComparisonRegions: u
}) => {
  const [e, a] = s(null), [l, c] = s([]);
  v(() => {
    e && f(e, l);
  }, [e, l]);
  const C = (o) => {
    const i = n.array.find((m) => m.regionCode === o.value);
    i && (a(i), c(
      u ? [] : p.filter(
        (m) => m.regionCode !== i.regionCode
      )
    ));
  }, g = (o) => {
    o.preventDefault(), r && (a(r), c(p));
  }, h = b(y, n);
  return /* @__PURE__ */ t.createElement(G, null, /* @__PURE__ */ t.createElement(
    E,
    {
      name: "primary-region-input",
      generateChoices: h,
      label: "Stedsnavn",
      onChange: C,
      placeholder: "Skriv stedsnavn"
    }
  ), !!r && /* @__PURE__ */ t.createElement(P, { className: "bl-p-t-2" }, /* @__PURE__ */ t.createElement(
    S,
    {
      styleType: "secondary",
      iconName: "close",
      isSmall: !0,
      onClick: g
    },
    "Avbryt"
  )));
};
export {
  mt as default
};
//# sourceMappingURL=index.es52.js.map
